/**
 * ACCUEIL / DASHBOARD
 */
export const DASHBOARD_ROUTE_PATH = 'dashboard';

/**
 * ERROR
 */
export const ERROR_PAGE_ROUTE_PATH = 'error';
export const DOMAIN_TRIAL_ROUTE_PATH = 'domain-trial-period';
export const DOMAIN_TRIAL_ROUTE_FULL_PATH = '/creation-entreprise/domain-trial-period';
